import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import AppUrl from "../../RestApi/AppUrl";
import RestClient from "../../RestApi/RestClient";
import topBannerCss from "./TopBanner.module.css";
import Fade from "react-reveal/Fade";
export default function TopBanner() {
  const [pageTitle, setPageTitle] = useState({
    title: "...",
    subTitle: "...",
  });
  useEffect(() => {
    RestClient.GetRequest(AppUrl.HomeTopTitle)
      .then((result) =>
        setPageTitle({
          title: result[0]["home_title"],
          subtitle: result[0]["home_subtitle"],
        })
      )
      .catch((err) => {
        setPageTitle({
          title: "???",
          subTitle: "???",
        });
      });
  }, []);
  return (
    <>
      <Container
        fluid={true}
        className={`${topBannerCss.topBannerfixed} p-0 d-flex align-items-center justify-content-center`}
      >
        <div className={`${topBannerCss.topBannerOverly}`}></div>
        <Container className=" g-0">
          <Row className="text-white d-flex justify-content-center text-center">
            <Col md={4} sm={12} lg={4}></Col>
            <Col
              md={4}
              sm={12}
              lg={4}
              className={`${topBannerCss.topbannerContent}`}
            >
              <Fade top>
                <h1 className={`${topBannerCss.topbannerTitle}`}>
                  {pageTitle.title}
                </h1>

                <h4 className={`${topBannerCss.topsubTitle}`}>
                  {pageTitle.subtitle}
                </h4>
              </Fade>
              <Button variant="primary">Learn More</Button>
            </Col>
            <Col md={4} sm={12} lg={4}></Col>
          </Row>
        </Container>
      </Container>
    </>
  );
}
